<script>
  import Layout from '@layout/main'
  import SectionBanner from './components/SectionBanner'
  // import SectionAbout from './components/SectionSolution'
  import SectionProducts from './components/SectionProducts'
  import SectionEvent from './components/SectionEvent'
  import SectionNews from './components/SectionNews'
  import SectionSupport from './components/SectionSupport'
  import SectionSubscription from './components/SectionSubscription'
  import SectionMobileNews from './components/SectionMobileNews'
  import SectionMobileMenuBox from './components/SectionMobileMenuBox'
  import { globalComputed, optionComputed } from "@store/helpers";
  import { FAKE_EVENT_LIST_2 } from "@src/config/fake-evnet";


  export default {
    components: {
      Layout,
      SectionBanner,
      SectionProducts,
      SectionEvent,
      SectionNews,
      SectionSupport,
      SectionSubscription,
      SectionMobileNews,
      SectionMobileMenuBox
    },
    props: {
      module: {
        type: Object,
        default: () => {
          return {}
        },
      }
    },
    data() {
      return {
        test: FAKE_EVENT_LIST_2
      }
    },
    computed: {
      ...globalComputed,
      ...optionComputed
    }
  }
</script>
<template>
  <Layout>
    <div :class="$style.home">
      <SectionBanner
        v-if="module.slideshow"
        :list="module.slideshow"
      />
      <SectionProducts
        v-if="!!productCategory[0]"
        :list="productCategory"
        class="d-md-block d-none"
      />
      <SectionEvent
        v-if="!!module.events[0]"
        :event-list="module.events"
        class="d-md-block d-none"
      />
      <SectionNews
        v-if="!!module.promotion[0] || !!module.bulletin[0]"
        :promotion-list="module.promotion"
        :bulletin-list="module.bulletin"
        class="d-md-block d-none"
      />
      <SectionSupport
        class="d-md-block d-none"
      />
      <SectionSubscription
        class="d-md-block d-none"
      />
      <SectionMobileNews
        v-if="!!module.promotion[0]"
        class="d-md-none d-block"
        :promotion-list="module.promotion"
      />
      <SectionMobileMenuBox  class="d-md-none d-block"/>
    </div>
    
  </Layout>
</template>
<style lang="scss" module>
  .home{
    @include max-md {
      background: transparent linear-gradient(180deg, rgba(244, 246, 250, 1) 0%, rgba(255, 255, 255, 1) 100%) 0% 0% no-repeat padding-box;
    }
  }
</style>
